import { render, staticRenderFns } from "./OrdersMainPage.vue?vue&type=template&id=14e397a0&scoped=true&"
import script from "./OrdersMainPage.vue?vue&type=script&lang=js&"
export * from "./OrdersMainPage.vue?vue&type=script&lang=js&"
import style0 from "./OrdersMainPage.vue?vue&type=style&index=0&id=14e397a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14e397a0",
  null
  
)

export default component.exports